export default "__VITE_ASSET__1a562bf6__"